import React, { ReactNode } from "react";
import {
  Box,
  Container,
  Divider,
  Fade,
  Modal as MuiModal,
  Paper,
  Typography,
} from "@mui/material";
import Button from "./Button";
import { Close } from "@mui/icons-material";
import theme from "../../theme";

interface Props {
  open: boolean;
  onClose: () => void;
  onSave?: () => void;
  children: ReactNode;
  title: string;
  loading?: boolean;
}

const Modal: React.FC<Props> = (props) => {
  const { open, onClose, onSave, children, title, loading } = props;

  const handleSaveClick = () => {
    onSave && onSave();
  };

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      disableAutoFocus={true}
      closeAfterTransition={true}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade in={open}>
        <Paper
          sx={{
            width: { lg: 1024, md: 900, xs: window.innerWidth },
            height: { md: "auto", xs: window.innerHeight },
            overflow: "auto",
            paddingY: 3,
          }}
        >
          <Container>
            <Box display="flex" flexDirection="column" gap={2}>
              <Box
                display="flex"
                flexDirection="row"
                width="100%"
                justifyContent="space-between"
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Typography variant="h4" fontWeight="700">
                    {title}
                  </Typography>
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="flex-end"
                >
                  <Button
                    variant={"contained"}
                    color={"inherit"}
                    onClick={onClose}
                    icon={<Close />}
                  />
                </Box>
              </Box>
              <Divider />
              <Box display="flex" flexDirection="row" justifyContent="center">
                {children}
              </Box>
              {!!onSave && (
                <>
                  <Divider />
                  <Box
                    display="flex"
                    flexDirection="row"
                    width="100%"
                    justifyContent="flex-end"
                    gap={2}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      color={theme.palette.text.secondary}
                    >
                      <Button label="Cancel" cancel onClick={onClose} />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                    >
                      <Button
                        label="Save"
                        variant={"contained"}
                        color={"primary"}
                        onClick={handleSaveClick}
                        disabled={loading}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Container>
        </Paper>
      </Fade>
    </MuiModal>
  );
};

export default Modal;
